<script>
import { getDateOfPlanning, getPossibleStartDates, getShortDateDisplay, getDateValue, createOneMenu } from '@/services/MenuMakerServices';
import { readAllCheatMeals } from '@/services/CheatMealServices';

export default {
  name: 'MenuMaker',
  props: {
    date: { type: String, required: true } // e.g. "2026-06-14"
  },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      autoSaveTimer: null,
      showDraftSavedAlert: false,
      //
      dateOfPlanning: {},
      //
      possibleStartDates: [],
      selectedStartDate: null,
      selectedWeekDays: [],
      //
      startPlanningTheMenu: false,
      readyToReviewAndSave: false,
      //
      menuData: null,
      //
      newMealText: '',
      newMealDay: '',
      newMealMeal: '',
      mealOptions: [
        { label: 'Meal 1', value: 1 },
        { label: 'Meal 2', value: 2 },
        { label: 'Meal 3', value: 3 },
        { label: 'Meal 4', value: 4 },
        { label: 'Meal 5', value: 5 },
        { label: 'Meal 6', value: 6 },
      ],
      //
      dateCopyFrom: '',
      dateCopyTo: '',
      //
      cheatMealDay: '',
      cheatMealMeal: '',
      cheatMealOptions: null,

    }
  },
  computed: {
    allowAddThisMeal() {
      return this.newMealDay && this.newMealMeal && this.newMealText.trim();
    },
    allowCopyThisMeal() {
      return this.dateCopyFrom && this.dateCopyTo && (this.dateCopyFrom !== this.dateCopyTo);
    },
    cIds() {
      return this.cheatMealOptions ? Object.keys(this.cheatMealOptions) : [];
    },
    allowAddCheatMeals() {
      return this.cheatMealDay && this.cheatMealMeal;
    }
  },
  watch: {
    selectedStartDate: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.generateWeekDays(newVal);
      }
    },
  },
  methods: {
    // autosave
    startAutoSave() {
      console.log('*** starting auto-save timer ***');
      if (this.autoSaveTimer) {
        clearInterval(this.autoSaveTimer);
      }

      // const timerInterval = 60000; // every 60 seconds
      const timerInterval = 30000; // every 30 seconds
      this.autoSaveTimer = setInterval(() => {
        if (this.menuData) {
          this.updateCookieMenuMaker();
          this.showDraftSaved();
        }
      }, timerInterval);
    },
    stopAutoSave() {
      if (this.autoSaveTimer) {
        clearInterval(this.autoSaveTimer);
        this.autoSaveTimer = null;
      }
    },
    showDraftSaved() {
      this.showDraftSavedAlert = true;
      setTimeout(() => {
        this.showDraftSavedAlert = false;
      }, 1300); // show for 1.3 seconds
    },
    updateCookieMenuMaker() {
      this.$cookies.remove('menumaker');
      this.$cookies.set('menumaker', this.menuData, '1 week');
      console.log('*** updated the cookie ***', this.menuData);
    },

    // new menu config
    discardMenuAndStartOver() {
      console.log('*** starting discardMenuAndStartOver() ***');
      this.stopAutoSave();
      this.$cookies.remove('menumaker');
      window.location.reload();
    },
    generateWeekDays(startValue) {
      const startDate = new Date(startValue);
      this.selectedWeekDays = [];

      for (let i = 1; i <= 7; i++) {
        const day = new Date(startDate);
        day.setDate(startDate.getDate() + i);

        this.selectedWeekDays.push({
          display: getShortDateDisplay(day),
          value: getDateValue(day)
        });
      }
      console.log('*** selectedWeekDays ***', this.selectedWeekDays);
    },
    startPlanning() {
      console.log('*** start planning the menu ***');

      let newMenu = {
        dateOfPlanning: this.dateOfPlanning,
        selectedStartDate: this.selectedStartDate,
        selectedWeekDays: this.selectedWeekDays,
        menu: [],
        scheduledCheatMealIds: [],
      };

      for (let day of this.selectedWeekDays) {
        const n = {
          date: day,
          meals: {
            meal1: '',
            meal2: '',
            meal3: '',
            meal4: '',
            meal5: '',
            meal6: '',
          },
        };
        newMenu.menu.push(n);
      }
      this.menuData = newMenu;
      console.log('*** menuData ***', this.menuData);

      // update cookie
      this.updateCookieMenuMaker();

      // toggle the menu-planner
      this.startPlanningTheMenu = true;

      // start auto-save
      this.startAutoSave();
    },

    // planning the menu
    addThisMeal() {
      console.log('*** starting addThisMeal() ***');

      const targetDay = this.menuData.menu.find(day => day.date.value === this.newMealDay);
      if (targetDay) {
        targetDay.meals[`meal${this.newMealMeal}`] = this.newMealText.trim();
      }

      // Update cookie so it persists across refreshes
      this.updateCookieMenuMaker();

      this.newMealText = '';
      console.log('*** updated menuData ***', this.menuData);
    },
    copyMealFromTo() {
      console.log('*** starting copyMealFromTo() ***');

      const fromDay = this.menuData.menu.find(day => day.date.value === this.dateCopyFrom);
      const toDay = this.menuData.menu.find(day => day.date.value === this.dateCopyTo);

      if (fromDay && toDay) {
        // Deep copy all meals from source day to target day
        toDay.meals = { ...fromDay.meals };

        this.updateCookieMenuMaker();
        this.dateCopyTo = '';
      }

    },
    addCheatMeal(cId) {
      console.log('*** starting addCheatMeal(cId) ***', cId, this.cheatMealDay, this.cheatMealMeal);

      // add the cheatMeal to the menu
      const targetDay = this.menuData.menu.find(day => day.date.value === this.cheatMealDay);
      if (targetDay) {
        targetDay.meals[`meal${this.cheatMealMeal}`] = `CHEAT MEAL — ${this.cheatMealOptions[cId].craving}`;

        // Update cookie so it persists across refreshes
        this.updateCookieMenuMaker();
      }

      // record the cheatMealId
      if (!this.menuData.scheduledCheatMealIds.includes(cId)) {
        this.menuData.scheduledCheatMealIds.push(cId);
      }


      // close the "Add a Cheat Meal" expansion panel
      this.$nextTick(() => {
        this.cheatMealMeal = '';

        const cheatPanel = document.getElementById('cheat-meal-panel-title');
        if (cheatPanel) { cheatPanel.click() }
      });


    },

    // save to dbase
    async saveThisMenu() {
      console.log('*** starting saveThisMenu() ***');
      this.updateCookieMenuMaker();

      const successfullySavedThisMenu = await createOneMenu(this.uId, this.token, this.menuData, this.cheatMealOptions);
      if (successfullySavedThisMenu) {
        console.log('*** yes, successfully saved this menu ***', successfullySavedThisMenu);
        this.stopAutoSave(); // clean up the autosave after successful save to dbase

        // show the user a list of all menus they've created
        this.$router.push('/menus');
      }
    },
  },
  beforeUnmount() {
    this.stopAutoSave();
  },
  async created() {
    console.clear();

    // check for cookie
    const cookieMenu = this.$cookies.get('menumaker');
    if (cookieMenu) {

      console.log('*** cookie.menuData exists ***', cookieMenu);

      this.menuData = { ...cookieMenu };
      this.dateOfPlanning = cookieMenu.dateOfPlanning;
      this.selectedStartDate = cookieMenu.selectedStartDate;
      this.selectedWeekDays = cookieMenu.selectedWeekDays;
      this.startPlanningTheMenu = true;

      // start autosave
      this.$nextTick(() => {
        this.startAutoSave();
      });

    } else {

      this.dateOfPlanning = getDateOfPlanning();
      this.possibleStartDates = getPossibleStartDates();
      this.selectedStartDate = this.possibleStartDates[0].value; // Default to most recent Sunday

      console.log('*** possibleStartDates ***', this.possibleStartDates);
      console.log('*** selectedStartDate ***', this.selectedStartDate);
      console.log('*** dateOfPlanning ***', this.dateOfPlanning);

    }

    // get cheatMeals
    this.cheatMealOptions = await readAllCheatMeals(this.uId, this.token);
    console.log('*** all cheatMeals ***', this.cheatMealOptions);

  },

}
</script>

<template>
<div id="menu-maker-page">

  <div id="heading" class="d-flex justify-space-between align-start">
    <div class="text-center font-italic">
      <h1>MENU</h1>
      <h3>Maker <span>2000</span></h3>
    </div>
    <div class="text-end">
      <p>
        <b>Date of Planning:</b> <br />
      </p>
      <p class="date-of-planning">{{ dateOfPlanning.display || '' }}</p>
      <p @click.prevent="discardMenuAndStartOver" class="discard-menu-start-over mt-4 text-body-2 text-lowercase text-red-lighten-3 font-italic">
        discard menu & start over
      </p>
    </div>
  </div>


  <!-- AUTO-SAVE ALERT -->
  <v-alert v-if="showDraftSavedAlert"
           color="light-blue"
           density="compact"
           class="mx-auto"
           style="position: fixed; top: 72px; width: 320px; left: 50%; transform: translateX(-50%); max-width: 320px; z-index: 9999;"
           closable
  >Draft saved</v-alert>



  <!-- MENU MAKER CONFIG -->
  <div v-if="!startPlanningTheMenu" id="setup-the-menu-maker" class="my-12">

    <!-- Select: Menu Start Date -->
    <div id="start-date-selector">
      <v-select
      v-model="selectedStartDate"
      :items="possibleStartDates"
      item-title="display"
      item-value="value"
      label="Select Start Date"
      variant="outlined"
      density="comfortable"
      />
    </div>

    <!-- Grid: Selected Week -->
    <div class="mt-2">
      <h3 class="mb-4 text-h6">Plan a Menu for the Week of:</h3>

      <div id="grid-selected-week-days" class="w-100 d-flex justify-start">
        <div v-for="(day, index) in selectedWeekDays" :key="index" class="text-center pa-2">
          <p class="font-weight-bold mb-1">{{ day.display.split(',')[0] }}</p>
          <p>{{ day.display.split(', ')[1] }}</p>
        </div>
      </div>
    </div>

    <!-- Button: Start Planning the Menu -->
    <div class="mt-8 text-center">
      <v-btn @click="startPlanning" color="green-lighten-2">
        Start Planning the Menu
      </v-btn>
    </div>

  </div> <!-- end MenuMakerConfig -->


  <!-- PLAN/BUILD THE MENU -->
  <div v-if="startPlanningTheMenu" id="enter-data-section" class="my-12">

    <!-- table -->
    <div id="table-menu-data">
      <h3 class="mb-4">
        <span class="pe-2">Menu for the week of:</span>
        {{ selectedWeekDays[0]?.display.split(', ')[1] }} - {{ selectedWeekDays[6]?.display.split(', ')[1] }}
      </h3>
      <v-table v-if="menuData" fixed-header class="sticky-table">
        <thead>
          <tr>
            <th class="bg-grey-lighten-2 sticky-col">&nbsp;</th>
            <th v-for="(day, index) in menuData.menu" :key="index" class="bg-grey-lighten-2">
              {{ day.date?.display }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="mealNum in 6" :key="mealNum">
            <td class="bg-grey-lighten-2 sticky-col text-center"><strong>Meal {{ mealNum }}</strong></td>
            <td v-for="(day, i) in menuData.menu" :key="i"
                :class="day.meals[`meal${mealNum}`] ? 'cell-has-content' : ''"
            >{{ day.meals[`meal${mealNum}`] || '' }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>


    <!-- accordion -->
    <v-expansion-panels v-if="!readyToReviewAndSave" class="mt-12" variant="popout">

      <!-- enter a meal -->
      <v-expansion-panel>
        <v-expansion-panel-title color="green-lighten-3 font-weight-bold">Enter a Meal</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div id="enter-a-meal" class="my-8">
            <h3 class="mb-4 text-capitalize">enter a meal</h3>
            <div class="d-flex flex-column flex-sm-row justify-space-between ga-4">
              <v-select v-model="newMealDay"
                        :items="selectedWeekDays"
                        item-title="display"
                        item-value="value"
                        label="Day"
                        variant="outlined"
                        density="comfortable"
                        class="flex-grow-1 me-sm-4"
              ></v-select>
              <v-select v-model="newMealMeal"
                        :items="mealOptions"
                        item-title="label"
                        item-value="value"
                        label="Meal Slot"
                        variant="outlined"
                        density="comfortable"
                        class="flex-grow-1"
              ></v-select>
            </div>
            <v-textarea v-model="newMealText"
                        label="Meal Description"
                        placeholder="e.g. Grilled chicken, rice, broccoli"
                        variant="outlined"
                        density="comfortable"
                        rows="3"
                        auto-grow
                        clearable
                        class="ga-4"
            ></v-textarea>
            <div class="d-flex justify-end">
              <v-btn @click.prevent="addThisMeal"
                     class="text-capitalize"
                     :color="allowAddThisMeal ? 'green-lighten-3' : ''"
                     :disabled="!allowAddThisMeal"
              >Add this meal</v-btn>
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- copy from / copy to -->
      <v-expansion-panel>
        <v-expansion-panel-title color="green-lighten-3 font-weight-bold">Copy Meals from One Day to Another</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div id="copy-from-copy-to" class="mt-12 mb-8">
            <h3 class="mb-4 text-capitalize">Copy All meals</h3>

            <div class="mb-4 d-flex ga-4 align-center">
              <v-select v-model="dateCopyFrom"
                        :items="selectedWeekDays"
                        item-title="display"
                        item-value="value"
                        label="Copy From"
                        variant="outlined"
                        density="comfortable"
                        class="flex-grow-1 w-100"
                        hide-details
              ></v-select>
              <v-icon class="mx-2 mx-sm-4 my-4">mdi-arrow-right-bold</v-icon>
              <v-select v-model="dateCopyTo"
                        :items="selectedWeekDays"
                        item-title="display"
                        item-value="value"
                        label="Copy From"
                        variant="outlined"
                        density="comfortable"
                        class="flex-grow-1 w-100"
                        hide-details
              ></v-select>
            </div>
            <div class="d-flex justify-end">
              <v-btn @click.prevent="copyMealFromTo"
                     class="text-capitalize"
                     :color="allowCopyThisMeal ? 'green-lighten-3' : ''"
                     :disabled="!allowCopyThisMeal"
              >Copy Meals</v-btn>
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- add a cheat meal -->
      <v-expansion-panel v-if="cheatMealOptions">
        <v-expansion-panel-title id="cheat-meal-panel-title" color="green-lighten-3 font-weight-bold">Add a Cheat Meal</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div id="add-cheat-meal">

            <v-select v-model="cheatMealDay"
                      :items="selectedWeekDays"
                      item-title="display"
                      item-value="value"
                      label="Date of Cheat Meal"
                      variant="outlined"
                      density="comfortable"
                      class="my-4 flex-grow-1 w-100"
                      hide-details
            ></v-select>
            <v-select v-model="cheatMealMeal"
                      :items="mealOptions"
                      item-title="label"
                      item-value="value"
                      label="Cheat Meal Slot"
                      variant="outlined"
                      density="comfortable"
                      class="mt-4 flex-grow-1"
            ></v-select>

            <div class="d-flex flex-wrap">

              <v-card v-for="cId in cIds"
                      :key="cId"
                      class="cheat-meal-option pa-2 bg-red d-flex flex-column justify-space-between"
              >
                <h3><b>{{ cheatMealOptions[cId].craving }}</b></h3>
                <div class="mt-4 d-flex justify-end">
                  <v-btn @click.prevent="addCheatMeal(cId)"
                         class="text-lowercase"
                         density="compact"
                         :color="allowAddCheatMeals ? 'green-lighten-3' : ''"
                         :disabled="!allowAddCheatMeals"
                  >add to menu</v-btn>
                </div>
              </v-card>

            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>


    <div v-if="!readyToReviewAndSave" class="mt-16 py-8 text-center border-solid">
      <h3>Finished Planning Your Menu?</h3>
      <v-btn @click.prevent="readyToReviewAndSave = true"
             class="mt-2 text-capitalize"
             color="yellow-darken-4"
      >Review & Save</v-btn>
    </div>

  </div> <!-- end PlanBuildTheMenu -->


  <!-- REVIEW & SAVE -->
  <div v-if="readyToReviewAndSave" class="pa-4 border-solid bg-red-lighten-4">
    <h3>Please review your menu (above)</h3>
    <h4><i>If everything looks ok, then click "Save"</i></h4>
    <div class="mt-3 d-flex justify-space-between">
      <v-btn @click.prevent="readyToReviewAndSave = false"
             color="red-lighten-2"
             class="text-capitalize"
      >Go Back
      </v-btn>
      <v-btn @click.prevent="saveThisMenu"
             color="green-lighten-2"
      >Save Menu</v-btn>
    </div>
  </div> <!-- end Review&Save -->



</div>
</template>

<style lang="scss" scoped>
#menu-maker-page {
  padding: 24px 12px 64px 12px;
  @media screen and (min-width: 768px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  #heading {
    h1 {
      font-size: 32px;
      line-height: 32px;
      letter-spacing: 2px;
    }
    h3 {
      letter-spacing: 3.8px;
      span { letter-spacing: 1.5px; }
    }
    .date-of-planning { text-decoration: underline double; }
    .discard-menu-start-over:hover { cursor: pointer; }
  }

  #grid-selected-week-days {
    div {
      border: 1px solid gray;
      &:not(:last-child) { border-right: none; }
      p:first-child { border-bottom: 1px solid black; }
    }
  }

  #table-menu-data {
    overflow: auto;

    .sticky-table {
      table {
        border-collapse: collapse;
        min-width: 100%; /* ensures horizontal scroll appears */
      }
    }

    th, td {
      border: 0.5px solid gray;
      white-space: pre-line;
      padding: 8px 12px;
      text-align: left;
    }
    th {
      text-align: center;
      position: sticky;
      top: 0;
      z-index: 10;
      font-weight: bold;
      &:first-child {
        min-width: 84px;
        left: 0;
        z-index: 20; /* higher z so it sits on top of other headers */
      }
      &:not(:first-child) { min-width: 124px; }
    }
    .sticky-col {
      position: sticky;
      left: 0;
      z-index: 15;
      font-weight: bold;
    }
    td.cell-has-content {
      min-width: 258px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

  }

  //#copy-from-copy-to {
  //  .v-input .v-input__details { padding: 0; height: 0; }
  //}

  #add-cheat-meal {
    .cheat-meal-option {
      width: 44%;
      margin: 12px 8px;
    }
  }

}
</style>
